import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFormValues } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';

import { Scrollbars } from 'react-custom-scrollbars';

import OrderNotesItem from 'components/patient/PatientProfile/Notes/NotesItem';
import OrderNotesForm from 'components/patient/PatientProfile/Notes/NotesForm';

import OrderNotesFilterForm from './OrderNotesFilterForm';

const styles = theme => ({
  root: {
    width: 480,
    textAlign: 'left',
    marginBottom: 0,
  },
  list: {
    padding: '16px 16px 0',
  },
  header: {
    margin: '0 16px',
    paddingBottom: 8,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  footer: {
    margin: '0 16px',
    paddingTop: 4,
    borderTop: `1px solid ${theme.palette.primary.A100}`,
  },
  typography: {
    margin: '16px 0',
  },
});

class OrderNotes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
    };

    this.onItemEditChange = this.onItemEditChange.bind(this);
  }

  onItemEditChange({ edit }) {
    this.setState({ edit });
  }

  render() {
    const {
      classes,
      onSubmitSuccess,
      onSubmitButtonBlur,
      rootRef,
      createInputRef,
      business,
      workflowStateFilter,
      disabled,
      ...otherProps
    } = this.props;
    const { edit } = this.state;
    const filteredNotes = workflowStateFilter.length > 0
      ? otherProps['Order Notes'].filter(item => (workflowStateFilter.indexOf(null) !== -1
        && (item['Notes Category'].length === 0 || item['Notes Category'].filter(categoryItem => !categoryItem['Workflow State'].ID).length > 0))
        || item['Notes Category']
          .filter(categoryItem => categoryItem['Workflow State'] && workflowStateFilter.indexOf(categoryItem['Workflow State'].ID) !== -1).length > 0)
      : otherProps['Order Notes'];
    return (
      <div
        ref={rootRef}
        className={classes.root}
      >
        <div className={classes.header}>
          <OrderNotesFilterForm form={`${otherProps['Order ID']}-notesFilter`} />
        </div>
        {filteredNotes && filteredNotes.length > 0 ? (
          <Scrollbars
            autoHeight
            autoHeightMin={0}
            autoHeightMax={250}
            thumbMinSize={30}
            universal
            renderTrackHorizontal={props => (
              <div {...props} className="track-horizontal" style={{ display: 'none' }} />
            )}
          >
            <List className={classes.list}>
              {filteredNotes.map(item => (
                <OrderNotesItem
                  key={item.ID}
                  business={business}
                  onItemEditChange={this.onItemEditChange}
                  {...{ 'Order ID': otherProps['Order ID'] }}
                  disabled={disabled}
                  {...item}
                />
              ))}
            </List>
          </Scrollbars>
        ) : (<Typography className={classes.typography} variant="caption" align="center">There are no comments</Typography>)}
        {!edit &&
          <div className={classes.footer}>
            <OrderNotesForm
              {...{ 'Order ID': otherProps['Order ID'] }}
              {...{ 'Author ID': otherProps['Author ID'] }}
              form={`${otherProps['Order ID']}-order-note-create`}
              destroyOnUnmount={false}
              onSubmitSuccess={onSubmitSuccess}
              onSubmitButtonBlur={onSubmitButtonBlur}
              onSubmitButtonClick={onSubmitSuccess}
              inputRef={createInputRef}
              disabled={disabled}
            />
          </div>
        }
      </div>
    );
  }
}

OrderNotes.propTypes = {
  'Order ID': PropTypes.number.isRequired,
  'Author ID': PropTypes.number.isRequired,
  'Order Notes': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  onSubmitSuccess: PropTypes.func,
  onSubmitButtonBlur: PropTypes.func,
  rootRef: PropTypes.func,
  createInputRef: PropTypes.func,
  business: PropTypes.shape({
    ID: PropTypes.number,
    'Time Zone': PropTypes.string,
  }),
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    list: PropTypes.string.isRequired,
    footer: PropTypes.string.isRequired,
  }).isRequired,
};

OrderNotes.defaultProps = {
  onSubmitSuccess: () => {},
  onSubmitButtonBlur: () => {},
  rootRef: () => {},
  createInputRef: () => {},
  business: {},
  disabled: false,
};

const mapStateToProps = (store, ownProps) => {
  const notesFilterValues = getFormValues(`${ownProps['Order ID']}-notesFilter`)(store);
  const workflowStateFilter = [
    ...notesFilterValues
      && notesFilterValues.Intake ? [1] : [],
    ...notesFilterValues
      && notesFilterValues.Delivery ? [2] : [],
    ...notesFilterValues
      && notesFilterValues.Billing ? [3] : [],
    ...notesFilterValues
      && notesFilterValues.Collection ? [4] : [],
    ...notesFilterValues
      && notesFilterValues.Paid ? [5] : [],
    ...notesFilterValues
      && notesFilterValues.General ? [null] : [],
  ];
  return {
    workflowStateFilter,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(OrderNotes));



// WEBPACK FOOTER //
// ./src/components/workflow/OrderNotes/OrderNotes.js